import { formatPrice } from "helpers"
import { useRef } from "react"
import { useAppSelector } from "store/store";

const usePrintTrialBlance = ({ trialBalance, fromDate, toDate, trialBalance_sumAmountFinal }: { trialBalance: reportProfitAndLossDataType, fromDate: string, toDate: string, trialBalance_sumAmountFinal: any[] }) => {
    const contentRef = useRef<any>(null);
    const store = useAppSelector((x: any) => x);
    const businessnickName = store.businessReducer.business.business.nickName
    const { token, fiscalYearStartDate, fiscalYeaEndDate } = store.businessReducer.business;

    const currentDate = new Date()
    const persianDate = new Intl.DateTimeFormat('fa-IR').format(currentDate)
    const getSumAmount = (colName: "creditAmount" | "debtAmount" | "creditAmountOpening" | "debtAmountOpening" | "creditAmountNow" | "debtAmountNow") => {
        const finded = trialBalance_sumAmountFinal.find(x => x[colName])
        const sum = finded[colName]
        return sum
    }
    const getChildInfo = (item: balanceSheetChildType): JSX.Element => {
        const isCredit = item.creditAmount - item.debtAmount > 0
        const remain = formatPrice(Math.abs(item.creditAmount - item.debtAmount))
        if (item.childs && item.childs.length) {
            return (
                <>
                    <tr className="bg-gray-300">
                        <td className="border border-black p-2">{item.code}</td>
                        <td className="border border-black p-2">{item.title}</td>
                        <td className="border border-black p-2">{formatPrice(item.debtAmount)}</td>
                        <td className="border border-black p-2">{formatPrice(item.creditAmount)}</td>
                        <td className="border border-black p-2">{isCredit ? remain : 0} </td>
                        <td className="border border-black p-2">{!isCredit ? remain : 0}</td>
                    </tr>
                    {
                        item.childs?.map((row: balanceSheetChildType) => {
                            return getChildInfo(row)
                        })
                    }
                </>)
        } else {
            return (<tr className="">
                <td className="border border-black p-2">{item.code}</td>
                <td className="border border-black p-2">{item.title}</td>
                <td className="border border-black p-2">{formatPrice(item.debtAmount)}</td>
                <td className="border border-black p-2">{formatPrice(item.creditAmount)}</td>
                <td className="border border-black p-2">{isCredit ? remain : 0} </td>
                <td className="border border-black p-2">{!isCredit ? remain : 0}</td>
            </tr>
            )
        }
    }
    let content = <></>;
    if (trialBalance) {
        content = (
            <div ref={contentRef} className="m-8" dir="rtl">
                <div className="flex flex-col w-full">
                    <div className="place-content-center place-items-center flex flex-col">
                        <span className="font-bold">تراز آزمایشی</span>
                        <span className="">{businessnickName}</span>

                    </div>
                    <div className="justify-between flex">
                        <div>

                            <span>تاریخ چاپ: </span>
                            <span>{persianDate}</span>
                        </div>
                        <div className="flex gap-2">
                            <span>محدوده محاسبه :</span>
                            <span>{fromDate ? fromDate : fiscalYearStartDate}</span>
                            تا
                            <span>{toDate ? toDate : fiscalYeaEndDate}</span>


                        </div>

                    </div>
                    <table className=" border border-black ">
                        <thead>
                            <tr>
                                <th colSpan={2} className="border border-black p-2 text-center">مشخصات حساب</th>
                                <th colSpan={2} className="border p-2 border-black text-center">گردش عملیات</th>
                                <th colSpan={2} className="border p-2 border-black text-center"> مانده حساب</th>
                            </tr>
                            <tr>
                                <th className="p-2">کد</th>
                                <th className="border-l border-black p-2 text-left">نام</th>
                                <th className="p-2">بدهکار</th>
                                <th className="border-l border-black p-2 text-left">بستانکار</th>
                                <th className="p-2">بدهکار</th>
                                <th className="p-2 text-left">بستانکار</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                trialBalance.childs.map(x => {
                                    return getChildInfo(x)

                                })
                            }
                            <tr>
                                <td colSpan={2}>جمع کل</td>

                                <td>
                                    {formatPrice(getSumAmount("debtAmount"))}
                                </td>

                                <td>
                                    {formatPrice(getSumAmount("creditAmount"))}
                                </td>
                            </tr>
                        </tbody>

                    </table>
                </div>
            </div>
        );
    }
    return { content, contentRef }
}

export default usePrintTrialBlance;